import { useAccess } from './use-access';
import { canView, canEdit, canManage, canDelete, canRemoveSelf } from '@/lib/sharing/utils/permissions';
import type { Access } from '@/lib/sharing/utils/permissions';
import type { Requirement } from '@/lib/sharing/components/permission-gate';

// ---------------------------------------------------------------------------
// Internals
// ---------------------------------------------------------------------------

const CHECKS: Record<Requirement, (a: Access) => boolean> = {
  view: canView,
  edit: canEdit,
  manage: canManage,
  delete: canDelete,
  removeSelf: canRemoveSelf,
};

// ---------------------------------------------------------------------------
// useGatedActions
//
// Filters an array of action objects by the current user's permission on the
// given resource. Each action must have a `require` field of type Requirement.
//
// Returns an empty array when the resource is not in the entity store.
// ---------------------------------------------------------------------------

interface Gated {
  require: Requirement;
}

export function useGatedActions<T extends Gated>(resourceId: string | null | undefined, actions: T[]): T[] {
  const access = useAccess(resourceId);
  if (!access) return [];
  return actions.filter((a) => CHECKS[a.require](access));
}
